import React, { useRef, useEffect } from "react";
import { resizeCanvas, resizeCanvasToDisplaySize } from '../pages/Game/canvas/util';

const WaveformVisualizer = ({ rawData }) => {
    const canvasRef = useRef(null);

    const filterData = (rawData) => {
        const samples = 3000;
        const blockSize = Math.floor(rawData.length / samples);
        const filteredData = [];

        for (let i = 0; i < samples; i++) {
            let blockStart = blockSize * i;
            let sum = 0;
            for (let j = 0; j < blockSize; j++) {
                sum += Math.abs(rawData[blockStart + j]);
            }
            filteredData.push(sum / blockSize);
        }
        return filteredData;
    };

    const normalizeData = (filteredData) => {
        const multiplier = Math.max(...filteredData) !== 0 ? 1 / Math.max(...filteredData) : 1;
        return filteredData.map(n => n * multiplier);
    };

    const drawLineSegment = (ctx, baseLine, x, y, width, isEven) => {
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = "white";
        ctx.beginPath();
        y = isEven ? y : -y;
        ctx.moveTo(x, baseLine);
        ctx.lineTo(x, baseLine + y);
        ctx.lineTo(x + width, baseLine);
        ctx.stroke();
    };


    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        resizeCanvas(canvas);
        resizeCanvasToDisplaySize(canvas);

        const drawWaveform = (ctx, canvas, rawData) => {
            if (!rawData) return;
    
            const filteredData = filterData(rawData);
            const normalizedData = normalizeData(filteredData);
    
            const baseLine = canvas.height / 2;
            const width = canvas.width / normalizedData.length;
    
            for (let i = 0; i < normalizedData.length; i++) {
                const x = width * i;
                let height = normalizedData[i] * canvas.height / 3;
                drawLineSegment(ctx, baseLine, x, height, width, (i + 1) % 2);
            }
        };

        if (rawData) {
            drawWaveform(ctx, canvas, rawData);
        }
    }, [rawData]);

    return <canvas ref={canvasRef} className="waveform-visualizer" />;
};

export default WaveformVisualizer;